export default __webpack_public_path__ + "static/media/CleanproConfirmButton.a804bf23.png";